import _ from 'lodash';
import template from './addToCart.html';

class AddToCartComponent {
    /*@ngInject*/
    constructor(cartService, $rootScope, $uibModal, $timeout, constants, $window, dataContext, alertService, $scope, shopCartService, userService, catalogService, $q) {
        this.$rootScope = $rootScope;
        this.cartService = cartService;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.constants = constants;
        this.$window = $window;
        this.alertService = alertService;
        this.$scope = $scope;
        this.shopCartService = shopCartService;
        this.userService = userService;
        this.catalogService = catalogService;
        this.dataContext = dataContext;
        this.$q = $q;
        this.isRadioXT = false;
    }

    $onInit() {
        this.$scope.alertDialog = 'Keypad error';
        if (!_.isNumber(this.quantity)) {
            this.quantity = 1;
        }
        

        this.productIds = [ this.productId ];
        if(!_.isNil(this.groupedProductIds)) {
            this.productIds = this.groupedProductIds;
        }

        this.catalogService.getProduct(this.productIds).then(products => {
            this.properties = _.flatten(products.data.map(d => d.properties));
            this.products = products.data;
        });
    }

    addProductsToCart(productIds) {
        this.isLoading = true;
        this.$rootScope.$emit(this.constants.updatingCart, ['true']);
        this.$timeout(() => {
            if (_.isNil(this.quantity)) {
                this.quantity = 1;
            }

            //Check if there is an OfferId on the Query String - this is the upsell flag
            var offerId = 0;
            if (!_.isNil(this._getQueryStringValue('offer_id'))) {
                offerId = this._getQueryStringValue('offer_id');
            }

            this.cartService.addLineItems(productIds, this.quantity, offerId).then(() => {
                this.$rootScope.$emit(this.constants.updatingCart, ['false']);                
                this._openDialog(this.products.map(p => ({
                    quantity: this.quantity,
                    price: p.price.actualPrice.formattedAmount,
                    imageUrl: p.primaryImage.url,
                    name: p.name
                })));
                if (this.isRadioXT) {
                    this.cartService.addCoupon(this.constants.radioDeal.couponCode4G, 0, 0);
                }
            }).finally(() => this.isLoading = false);
        }, this.constants.inputDebounce);
    }

    validateCart() {
        this.$timeout(() => {
            if (this.userService.current.ServicePlanInfo.AdcServicePlan === 'VideoOnly') {
                let savApplicable = _.find(this.properties, { name: 'savApplicable' });
                if (!savApplicable || savApplicable.value !== 'True') {
                    this.alertService
                        .get(this.$scope.alertDialog)
                        .setType('danger')
                        .setMessage(`You cannot add ${this.name} to your cart on a Video Only plan.`)
                        .open();
                    return;
                }
            }

            this.isPurchaseValidForPanel().then((isPurchaseValid) => {
                if (isPurchaseValid) {
                    if (_.isNil(this.quantity)) {
                        this.quantity = 0;
                    }
                    this.$scope.alertDialog = 'Keypad error';

                    let promisesStack = [];
                    _.forEach(this.products, product => {
                        const skuManufacturer = _.find(product.properties, { name: 'SKUManufacturer' });
                        let fpwsSku = product.sku;
                        if (!_.isNil(skuManufacturer)) {
                            fpwsSku = skuManufacturer.value;
                        }

                        // if the product.maxQuantity is set, override the passed in value
                        let productMax = this.max;
                        if(!_.isNil(product.maxQuantity)) {
                            productMax = product.maxQuantity;
                        }

                        promisesStack.push(this.shopCartService.validateCartItems(this.quantity, productMax, fpwsSku, product.name));
                    });

                    this.$q.all(promisesStack).then(results => {
                        if (results.every(r => r === true)) {
                            this.alertService.get(this.$scope.alertDialog).close();

                             // if all products are valid, add them to the cart
                            this.addProductsToCart(this.productIds);
                        }
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }
                else {
                    this.$window.scrollTo(0, 0);
                }
            });
        },
        this.constants.inputDebounce);
    }

    isPurchaseValidForPanel() {
        return this.$q((resolve, reject) => {
            const listOfHubSpecificProducts = [
                this.constants.skus.frontpointRubberKeypad, this.constants.skus.frontpointTouchscreen, this.constants.skus.frontpointRubberKeypadV2
            ];
            const listOfXtSpecificProducts = [this.constants.skus.verizonLteRadio];
            this.dataContext.panel.getVersion().then(response => {
                let isValid = true;
                const panelType = response.PanelType;

                // Frontpoint panel specific checks
                const hubSpecific = _.filter(listOfHubSpecificProducts, o => this.products.map(p => p.sku).includes(o))
                    .length;
                const xtSpecific = _.filter(listOfXtSpecificProducts, o => this.products.map(p => p.sku).includes(o))
                    .length;
                // customer is trying to purchase hub specific product but doesn't currently own a hub. Check if
                // they have one currently in their cart
                var hasHub = _.some(this.constants.panelType.frontpointHub, (pt) => { return pt.toLowerCase() == panelType.toLowerCase(); });
                var hasXt = _.some(this.constants.panelType.simonXT, (pt) => { return pt.toLowerCase() == panelType.toLowerCase(); });
                if (xtSpecific > 0) {
                    this.isRadioXT = true;
                }
                if (hubSpecific > 0 && !hasHub) {
                    this.cartService.getCart()
                        .then((cartData) => {
                            // Ensure the customer doesn't have any version of the hub in their cart currently
                            const hubCount = _.filter(cartData.data.items.map(p => p.sku), o => this.constants.skus.frontpointHubVersions.includes(o)).length;
                            const bundledProductsHubCount = _.filter(this.products.map(p => p.sku), o => this.constants.skus.frontpointHubVersions.includes(o)).length;
                            if (hubCount < 1 && bundledProductsHubCount < 1) {
                                this.alertService
                                    .get(this.$scope.alertDialog)
                                    .setType('danger')
                                    .setMessage('You must have a Frontpoint Hub to purchase this product')
                                    .open();
                                isValid = false;
                            }
                            resolve(isValid);
                        });
                } else if (xtSpecific > 0 && !hasXt) {
                    // yes this error is specific to lte radio, it's the only product that is only applicable to simon xt
                    // we will have to make a code change no matter what to add more products to that list at which point we can 
                    // make the message more dynamic
                    this.alertService
                        .get(this.$scope.alertDialog)
                        .setType('danger')
                        .setMessage('The 4G LTE Radio is only compatible with Simon XT panels and will not work with the panel on your account.')
                        .open();
                    isValid = false;
                    resolve(isValid);
                }
                else
                {
                    resolve(isValid);
                }
            });
        });
    }

    _getQueryStringValue(key) {
        return decodeURIComponent(this.$window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
    }

    _openDialog(productsAddedToCart) {
        let modalInstance = this.$uibModal.open({
            template: '<fp-added-to-cart-modal config="config"></fp-added-to-cart-modal>',
            size: 'md',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    products: productsAddedToCart,
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            }
        });

        return modalInstance.result.then(() => {
            this.$rootScope.$broadcast('cartItemsChanged');
        });
    }
}

export default {
    template: template,
    bindings: {
        productId: '<',
        quantity: '=',
        max: '<',
        price: '<',
        imageUrl: '<',
        name: '<',
        sku: '<',
        isBuyable: '<',
        properties: '<',
        groupedProductIds: '<'
    },
    controller: AddToCartComponent
};